import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, of, switchMap } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { errorFromHttpErrorResponse } from '@core/services/request/util/error-from-http';
import { BillingReportRequestMapper } from '@core/domain/mappers/billing-report/billing-report-request.mapper';
import { ApiBillingReportRequestService } from '@core/api/services/my-invoices/billing-report-request.service';
import { myInvoicesActions } from '@store/actions/my-invoices.actions';

@Injectable()
export class BillingReportEffects {
  fetchRequestList$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(myInvoicesActions.fetchRequestList),
      switchMap(() =>
        this._apiRequest.fetchBillingReportRequest().pipe(
          map(BillingReportRequestMapper.requestFromApiToDomain),
          map((value) => value.data),
          map((data) => myInvoicesActions.setRequestList({ data })),
          catchError((error) => of(myInvoicesActions.setRequestListError({ error: errorFromHttpErrorResponse(error) })))
        )
      )
    );
  });
  constructor(
    private readonly _actions$: Actions,
    private readonly _apiRequest: ApiBillingReportRequestService
  ) {}
}
